import { Anchor } from './Anchor';

// TODO: in v9, move styled() from Anchor.jsx to here
export var StyledAnchor = Anchor;